import React, { useEffect, useState, createElement } from 'react';
import { Hero } from './components/Hero';
import { SignalsSection } from './components/SignalsSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PrivacySection } from './components/PrivacySection';
import { TeamsSection } from './components/TeamsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { NavBar } from './components/ui/NavBar';
import { WaitlistModal } from './components/modals/WaitlistModal';
import { supabase } from './lib/supabase';
import { CookieBanner } from './components/CookieBanner';
import { CookiePreferencesModal } from './components/modals/CookiePreferencesModal';
import { LinkedInTag } from './components/LinkedInTag';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const [showCookieModal, setShowCookieModal] = useState(false);
  const [cookiePreferences, setCookiePreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });
  useEffect(() => {
    // Add Inter font
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    // Add font-family to body
    document.body.style.fontFamily = 'Inter, sans-serif';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    // Check if user has already set cookie preferences
    const savedPreferences = localStorage.getItem('cookiePreferences');
    if (savedPreferences) {
      setCookiePreferences(JSON.parse(savedPreferences));
      setShowCookieBanner(false);
    }
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  const handleSubmit = async (email: string) => {
    setIsSubmitting(true);
    setError(null);
    try {
      const {
        error
      } = await supabase.from('waitlist').insert([{
        email,
        signed_up_at: new Date().toISOString()
      }]);
      if (error) throw error;
      setIsSubmitted(true);
      setSubmittedEmail(email);
      setIsModalOpen(true);
    } catch (err) {
      setError('Failed to join waitlist. Please try again.');
      console.error('Error saving to waitlist:', err);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleAcceptAllCookies = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true
    };
    setCookiePreferences(allAccepted);
    localStorage.setItem('cookiePreferences', JSON.stringify(allAccepted));
    setShowCookieBanner(false);
  };
  const handleSavePreferences = (preferences: typeof cookiePreferences) => {
    setCookiePreferences(preferences);
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    setShowCookieBanner(false);
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      {/* LinkedIn Insight Tag with the correct partner ID */}
      <LinkedInTag partnerId="7289172" data-id="element-1" />
      <NavBar onGetStarted={() => setIsModalOpen(true)} data-id="element-2" />
      <Hero onGetStarted={handleSubmit} isSubmitted={isSubmitted} submittedEmail={submittedEmail} data-id="element-3" />
      <SignalsSection onGetStarted={handleSubmit} isSubmitted={isSubmitted} submittedEmail={submittedEmail} data-id="element-4" />
      <HowItWorksSection data-id="element-5" />
      <PrivacySection data-id="element-6" />
      <TeamsSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <CtaSection onGetStarted={handleSubmit} isSubmitted={isSubmitted} submittedEmail={submittedEmail} data-id="element-9" />
      <Footer data-id="element-10" />
      <WaitlistModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-11" />
      {showCookieBanner && <CookieBanner onAcceptAll={handleAcceptAllCookies} onCustomize={() => setShowCookieModal(true)} data-id="element-12" />}
      <CookiePreferencesModal isOpen={showCookieModal} onClose={() => setShowCookieModal(false)} onSave={handleSavePreferences} preferences={cookiePreferences} data-id="element-13" />
    </div>;
}